import { autoQueueMatchupFound } from 'react/redux/actions/matchmaking';
import { showToast } from 'react/toasts/showToast';

// The server pushes auto_queue_match_update when auto-queue pairs the player.
// Records the matchup; if the match hasn't reached the match list yet, says
// so in a toast, since nothing on screen shows it.
export default function applyAutoQueueMatchUpdate(matchData, { findMatchById, dispatch }) {
	const matchup = { ...matchData, match_id: Number.parseInt(matchData.match_id) };
	const match = findMatchById(matchup.match_id);
	dispatch(autoQueueMatchupFound(matchup));
	if(!match) {
		showToast({ kind: 'warning', content: 'Match found, but it is not visible yet.' });
	}
}
